export function drawTelemetryTable({
  pdf,
  data,
  startY,
  type,
  pageHeight,
  margin,
}) {
  const baseRowHeight = 16;
  const lineHeight = 15;
  const pageWidth = pdf.internal.pageSize.getWidth();
  const usableWidth = pageWidth - margin * 2;

  // Columnas: [Punto | Valor | Fecha/Hora Lectura | Evento Logístico | Fecha/Hora Evento]
  const colWidths = [
    40, // Punto
    Math.max(70, usableWidth * 0.2), // Valor (Temp/Hum)
    Math.max(90, usableWidth * 0.2), // Fecha/Hora Lectura
    Math.max(100, usableWidth * 0.3), // Evento Logístico (name)
    Math.max(90, usableWidth * 0.2), // Fecha/Hora Evento
  ];

  const sumW = colWidths.reduce((a, b) => a + b, 0);
  if (sumW !== usableWidth) {
    colWidths[colWidths.length - 1] += usableWidth - sumW;
  }

  let y = startY;

  const formatData = (v) =>
    typeof v === "number" && isFinite(v) ? v.toFixed(2) : "-";

  const drawCell = (x, y, w, h, text = "") => {
    pdf.rect(x, y, w, h);
    if (text) {
      const tx = x + 5;
      const ty = y + 5 + 7;
      const wrapped = pdf.splitTextToSize(String(text), w - 10);
      pdf.text(wrapped, tx, ty);
    }
  };

  const drawTableHeader = () => {
    pdf.setFont("helvetica", "bold");
    let x = margin;

    drawCell(x, y, colWidths[0], baseRowHeight, "Punto");
    x += colWidths[0];

    drawCell(
      x,
      y,
      colWidths[1],
      baseRowHeight,
      type === "temp" ? "Temperatura (ºC)" : "Humedad (%)"
    );
    x += colWidths[1];

    drawCell(x, y, colWidths[2], baseRowHeight, "Fecha/Hora");
    x += colWidths[2];

    drawCell(x, y, colWidths[3], baseRowHeight, "Evento Logístico");
    x += colWidths[3];

    drawCell(x, y, colWidths[4], baseRowHeight, "Fecha/Hora Evento");

    y += baseRowHeight;
  };

  drawTableHeader();
  pdf.setFont("helvetica", "normal");

  data.forEach((item, idx) => {
    const punto = `${idx + 1}`;
    const valor =
      type === "temp" ? formatData(item?.temp) : formatData(item?.humidity);
    const fechaLectura = item?.date || "-";

    // Comprobación para varios eventos asociados a una misma medición
    const eventsArray = Array.isArray(item?.events)
      ? item.events
      : item?.isEvent
      ? [
          {
            name: item?.name || "",
            eventDate: item?.eventDate || "",
            ref: item?.ref,
          },
        ]
      : [];

    // Texto de la columna “Evento Logístico”
    const eventoNameText =
      eventsArray.length > 0
        ? eventsArray.map((ev) => ev.name || "").join("\n")
        : "";

    // Texto de la columna “Fecha/Hora Evento”
    const eventoDateText =
      eventsArray.length > 0
        ? eventsArray.map((ev) => ev.eventDate || "").join("\n")
        : "";

    let rowHeight = baseRowHeight;

    // Cálculo de líneas que ocuparía cada una de las columnas de texto largo
    const eventoNameLines = pdf.splitTextToSize(
      eventoNameText,
      colWidths[3] - 10
    );
    const eventoDateLines = pdf.splitTextToSize(
      eventoDateText,
      colWidths[4] - 10
    );

    // Número de líneas que ocupa la fila
    const linesForEvents = Math.max(
      eventoNameLines.length,
      eventoDateLines.length
    );

    if (linesForEvents > 1) {
      const extraLines = linesForEvents - 1;
      rowHeight = baseRowHeight + extraLines * lineHeight;
    }

    // Salto de página en caso de que las filas excedan el espacio disponible
    if (y + rowHeight > pageHeight - margin) {
      pdf.addPage();
      y = margin;
      drawTableHeader();
      pdf.setFont("helvetica", "normal");
    }

    let x = margin;
    drawCell(x, y, colWidths[0], rowHeight, punto);
    x += colWidths[0];

    drawCell(x, y, colWidths[1], rowHeight, valor);
    x += colWidths[1];

    drawCell(x, y, colWidths[2], rowHeight, fechaLectura);
    x += colWidths[2];

    drawCell(x, y, colWidths[3], rowHeight, eventoNameText);
    x += colWidths[3];

    drawCell(x, y, colWidths[4], rowHeight, eventoDateText);

    y += rowHeight;
  });
}
